import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData, Item } from 'types'
import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'

const ITEMS_MAX = 2

const ItemList_1 = ({
  items,
  is_short,
  titleElement,
  paragraphElement,
  titleHexa,
  titleColor,
  paragraphColor,
  paragraphHexa,
  subtitleHexa,
  height,
}: RealEstateDataPageComponentData) => {
  const [itemsArray, setItemsArray] = useState(groupByValue(items!, 'value'))
  const [selected, setSelected] = useState(Object(items!)[0].value)
  const [max, setMax] = useState(ITEMS_MAX)

  const [isMounted, setIsMounted] = useState(false)

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    setIsMobile(screen?.width < 992)
  }, [])

  function groupByValue(items: Item[], key: string) {
    return items.reduce((result: any, item: any) => {
      ;(result[item[key]] = result[item[key]] || []).push(item)
      return result
    }, {})
  }

  return (
    isMounted && (
      <section
        style={{ minHeight: height?.desktop }}
        className="item-list-1 p-y-config d-flex align-items-center"
      >
        <Container fluid>
          <Row
            className={
              'd-lg-flex align-items-center container-items ' + (max !== 99 ? 'is-summary' : '')
            }
            // style={{ minHeight: height?.desktop }}
          >
            <Col
              className="d-none d-lg-block list-item"
              lg={2}
            >
              {Object.keys(itemsArray).map((key, index) => (
                <h3
                  onClick={() => setSelected(key)}
                  key={key}
                  style={{ color: titleHexa }}
                  className={
                    'item-selector cursor-pointer ' +
                    (selected === key ? 'active' : '') +
                    ' ' +
                    titleColor
                  }
                >
                  {key}
                </h3>
              ))}
            </Col>
            <Col lg={{ span: 9, offset: 1 }}>
              {Object.keys(itemsArray).map(
                (key, index) =>
                  (index < max || !isMobile) && (
                    <div
                      className={
                        (!is_short ? 'is-singular' : 'is-multiple ') +
                        (selected !== key && !isMobile ? ' d-none ' : '')
                      }
                      // style={{ minHeight: height?.desktop }}
                      key={key}
                    >
                      {itemsArray[key].map(
                        ({ value, titles, paragraphs, image_gatsby }: Item, index: number) => (
                          <div
                            className={`list-item animate__animated animate__fadeIn ${
                              selected !== key
                                ? ' d-block d-lg-none'
                                : ' active ' + (is_short ? ' is-flex ' : '')
                            }`}
                            key={index}
                          >
                            {image_gatsby && ( //Imagen posición de desktop
                              <Image
                                image={image_gatsby!}
                                objectFit="cover"
                                alt={value!}
                                className="border-rounded ml-3 d-none d-lg-inline-block"
                              />
                            )}
                            <div>
                              {index === 0 && (
                                <ElementHTML
                                  elementType={'h3'}
                                  children={value || ''}
                                  style={{ color: titleHexa }}
                                  className={'d-block d-lg-none item-selector ' + titleColor}
                                />
                              )}
                              <div>
                                {image_gatsby && ( //Imagen posición de mobile
                                  <Image
                                    image={image_gatsby!}
                                    objectFit="cover"
                                    alt={value!}
                                    className="border-rounded ml-0 my-3 d-block d-lg-none"
                                  />
                                )}
                                {titles?.map((title: string, index: number) => (
                                  <ElementHTML
                                    style={{ color: titleHexa }}
                                    className={titleColor + ' title '}
                                    key={index}
                                    elementType={titleElement || 'h2'}
                                    children={title || ''}
                                  />
                                ))}
                                <div
                                  className={'divisor '}
                                  style={{ backgroundColor: subtitleHexa || paragraphHexa }}
                                ></div>
                                {paragraphs?.map((paragraph: string, index: number) => (
                                  <ElementHTML
                                    key={index}
                                    elementType={paragraphElement || 'p'}
                                    children={paragraph || ''}
                                    className={paragraphColor}
                                    style={{ color: paragraphHexa }}
                                  />
                                ))}
                              </div>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  ),
              )}
            </Col>
          </Row>
          {/* {itemsArray.length! > ITEMS_MAX && ( */}
          <button
            onClick={() => (max == 99 ? setMax(ITEMS_MAX) : setMax(99))}
            className={
              'btn btn-primary mx-auto border d-block d-lg-none ' +
              (max == 99 ? 'normal-position' : 'top-position')
            }
          >
            {max == 99 ? 'VER MENOS' : 'VER MÁS'}
          </button>
          {/* )} */}
        </Container>
      </section>
    )
  )
}

export default ItemList_1
